import React from "react";
import Typography from "@material-ui/core/Typography";
import { ApplicationState } from "../../store";
import * as APIStore from "../../store/APIStore";
import { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";
import RequestAccessToken from '../../util/authService';
import { Link, useHistory } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import TodayIcon from '@material-ui/icons/Today';
import TabPanel from '../patient/TabPanel/TabPanel';
import { formatDate } from "../common/DateHelper";


export interface PatientMedicalRecordsIndexProps {
    patientMedicalRecords: APIStore.PatientMedicalRecord[],
    MedicalRecord: APIStore.FocusMedicalRecordState,
    historicalMedicalRecords: APIStore.PatientMedicalRecord[],
}


const PatientMedicalRecordsIndex = (props: PatientMedicalRecordsIndexProps) => {
    let { patientMedicalRecords, MedicalRecord, requestPatientDocument, historicalMedicalRecords } = props;
    let [tokenState, setTokenState] = useState<APIStore.TokenType>();
    let [isDownLoadRequested, setDownLoadRequested] = useState(false);
    let [tabIndex, setTabIndex] = useState(0);

    if (!patientMedicalRecords?.length) {
        return (<>
        </>);
    }

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    const history = useHistory();

    useEffect(() => {
        if (MedicalRecord?.isLoaded) {
            if (MedicalRecord.medicalRecord && isDownLoadRequested) {

                const blbContent = new Blob([MedicalRecord.medicalRecord.content], { type: "text/plain" });
                let a = document.createElement("a")
                a.href = window.URL.createObjectURL(blbContent);
                a.download = MedicalRecord.medicalRecord.recordName;
                a.click();
                setDownLoadRequested(false)
            }
        }

    }, [tokenState, MedicalRecord])

    const handleTabChange = (event: any, newValue: number) => {
        setTabIndex(newValue);
    };


    const documentItemClick = (e: any,
        medicalRecord: APIStore.PatientMedicalRecord
    ) => {
        let ptId = medicalRecord.ptId;
        let name = medicalRecord.condensedName;
        history.push(`/record/document/${ptId}/${name}`);
    };

    const documentItemDownload = (e: any,
        medicalRecord: APIStore.PatientMedicalRecord
    ) => {
        let ptId = medicalRecord.ptId;
        let name = medicalRecord.condensedName;
        e.preventDefault();
        setDownLoadRequested(true)
        requestPatientDocument(ptId, name, tokenState?.accessToken)
    };


    return (
        <div>
            <Typography variant="body1" component="div" gutterBottom>
                <strong>Medical Records:</strong>
            </Typography>


            <AppBar position="static" >
                <Tabs
                    value={tabIndex}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleTabChange}
                    aria-label="documents tabs"
                >
                    <Tab  label={`Current (${patientMedicalRecords?.length})`}/>

                    <Tab  disabled={historicalMedicalRecords?.length > 0 ? false : true} label={`Previous (${historicalMedicalRecords?.length})`} />

                </Tabs>
            </AppBar>
            <TabPanel value={tabIndex} index={0}>
                <TableContainer>
                    <Table aria-label="current records table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Record Name</TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">Type</TableCell>
                                <TableCell align="right">Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {patientMedicalRecords.map((val: APIStore.PatientMedicalRecord) => (

                                <>
                                    <TableRow>
                                        <TableCell align="left">
                                            <p>
                                                {
                                                    val.recordName
                                                }
                                            </p>


                                        </TableCell>
                                        <TableCell align="left">

                                            <Link className="mui-auto-link" color="secondary" title="View" to="#" onClick={(e) => documentItemClick(e, val)} >View | </Link>
                                            <Link className="mui-auto-link" color="secondary" title="Download" to="#" onClick={(e) => documentItemDownload(e, val)} > Download</Link>

                                        </TableCell>
                                        <TableCell align="left">

                                            {
                                                val.recordType
                                            }

                                        </TableCell>

                                        <TableCell align="right">

                                            {formatDate(val.createdDate, true)}

                                        </TableCell>

                                    </TableRow>
                                </>

                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </TabPanel>

            <TabPanel value={tabIndex} index={1}>
                <TableContainer>
                    <Table aria-label="Previous records table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Record Name</TableCell>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">Type</TableCell>
                                <TableCell align="right">Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {historicalMedicalRecords?.map((val: APIStore.PatientMedicalRecord) => (

                                <>
                                    <TableRow>
                                        <TableCell align="left">
                                            <p>
                                                {
                                                    val.recordName
                                                }
                                            </p>


                                        </TableCell>
                                        <TableCell align="left">

                                            <Link className="mui-auto-link" color="secondary" title="View" to="#" onClick={(e) => documentItemClick(e, val)} >View | </Link>
                                            <Link className="mui-auto-link" color="secondary" title="Download" to="#" onClick={(e) => documentItemDownload(e, val)} > Download</Link>

                                        </TableCell>
                                        <TableCell align="left">

                                            {
                                                val.recordType
                                            }

                                        </TableCell>

                                        <TableCell align="right">

                                            {formatDate(val.createdDate, true)}

                                        </TableCell>

                                    </TableRow>
                                </>

                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </TabPanel>

        </div>
    )
}

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(PatientMedicalRecordsIndex as any);
